import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of, BehaviorSubject } from 'rxjs';

import { map, catchError, share } from 'rxjs/operators';
import { SharedService } from './sharedService';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Role } from '../entities/role';


@Injectable()
export class AuthService {
  private username$ = new BehaviorSubject<string>(undefined);
  private userRole$ = new BehaviorSubject<string>(undefined);
  accessToken: string
  constructor(private http: HttpClient, private sharedService: SharedService, public decoder: JwtHelperService) {  this.accessToken = sharedService.getAccessToken() }
 
  login(username: string, password: string): Observable<boolean> {
    return this.http.post<{ token: string }>(this.sharedService.apiUrl('auth/login'), { username: username, password: password })
      .pipe(
        map(result => {
         // if (result['statusCode'] === 200) {
            localStorage.setItem(this.accessToken, result.token);
            this.setUsername(username)
            this.setUserRole$(result['role'])
            return true;
        //  }
        }), catchError(
          
          (err) => throwError(err)
          
          )
      );
  }

  loginTEST(username: string, password: string): Observable<boolean> {


    localStorage.setItem(this.accessToken, 'fake_jwt_token');
    return Observable.create(function (observer) {

      var result = { result: true }
      if (username === 'admin' && password === 'admin') {
        result['role'] = Role.ADMIN
      }
      else if (username === 'registrator' && password === 'registrator') {
        result['role'] = Role.ADMIN
      }
      else if (username === 'badge' && password === 'badge') {
        result['role'] = Role.ADMIN
      }
      else {
        result['result'] = false;
        result['err'] = 401
      }
      observer.next(result);
      observer.complete();
    });


  }


  logout() {
    localStorage.removeItem(this.accessToken)
    localStorage.removeItem('username')
    localStorage.removeItem('userrole')
    this.setLoginStatus(false)
  }

  public get isloggedIn(): boolean {
    return (localStorage.getItem('rdf_fusacc_tkn') !== null);
  }

  @Output() loggedIn: EventEmitter<boolean> = new EventEmitter();
  setLoginStatus(obj) {
    this.loggedIn.emit(obj)
  }

  setUsername(obj) {
    this.username$.next(obj);
  }

  setUserRole$(obj) {
    this.userRole$.next(obj);
  }

  getUsername$(): Observable<any> {
    return this.username$.asObservable();
  }

  getUserRole$(): Observable<any> {
    return this.userRole$.asObservable();
  }

  getDecodedToken(){
    return this.decoder.decodeToken(this.decoder.tokenGetter())
  }

 


}
